import _objectSpread from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { MarkerEvent } from './MarkerEvent';

var debug = require('debug')('CRATE:Communication:MarkerManager:PingManger');

export var PingManager =
/*#__PURE__*/
function (_MarkerEvent) {
  _inherits(PingManager, _MarkerEvent);

  function PingManager(opts) {
    var _this;

    _classCallCheck(this, PingManager);

    var EventName = opts.EventName || 'Ping';
    _this = _possibleConstructorReturn(this, _getPrototypeOf(PingManager).call(this, _objectSpread({
      EventName: EventName
    }, opts)));
    /**
     * startimer A timer used for sending pings
     * @type {Timer}
     */

    _this._startTimer = {};
    _this._pingPeriod = opts.PingPeriod;
    /**
     * @todo: make ping interval as option
     */

    _this.startPing(_this._pingPeriod);

    return _this;
  }
  /**
   * startPing send periodically ping
   * @param  {[type]} interval [description]
   * @return {[type]}          [description]
   * @todo TODO: Make interval as global parameter
   */


  _createClass(PingManager, [{
    key: "startPing",
    value: function startPing(interval) {
      var _this2 = this;

      this._startTimer = setInterval(function () {
        _this2.broadcast(_this2._document.user);
      }, interval);
    }
    /**
     * stopPing stopPing
     * @todo  implement this function
     * @return {[type]} [description]
     */

  }, {
    key: "stopPing",
    value: function stopPing() {
      clearInterval(this._startTimer);
    }
    /**
     * receive at the reception of ping
     * @param  {[type]} origin [description]
     * @param  {[type]} pseudo [description]
     * @return {[type]}        [description]
     */

  }, {
    key: "receive",
    value: function receive(_ref) {
      var id = _ref.id,
          pseudo = _ref.pseudo;
      this.emit('Ping_received', {
        id: id,
        pseudo: pseudo
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.stopPing();
    }
  }]);

  return PingManager;
}(MarkerEvent);